export default __webpack_public_path__ + "a98d1bbdae0ddeaa7e255494866667ce.png";